//# sourceMappingURL=project_file.mjs.map
/// <reference types="./project_file.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $bit_array from "../../gleam_stdlib/gleam/bit_array.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $mime_types from "../../mime_types/mime_types.mjs";
import * as $json_ from "../../tiamat/gleam/json_.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import * as $docx from "../data/docx.mjs";
import * as $spreadsheet from "../data/spreadsheet.mjs";
import * as $language from "../data/translate/language.mjs";
import * as $iso639 from "../data/translate/language/iso639.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, Empty as $Empty, CustomType as $CustomType } from "../gleam.mjs";

export class ProjectFile extends $CustomType {
  constructor(id, org_id, project_id, url, status, version, created_at, name, metadata) {
    super();
    this.id = id;
    this.org_id = org_id;
    this.project_id = project_id;
    this.url = url;
    this.status = status;
    this.version = version;
    this.created_at = created_at;
    this.name = name;
    this.metadata = metadata;
  }
}
export const ProjectFile$ProjectFile = (id, org_id, project_id, url, status, version, created_at, name, metadata) =>
  new ProjectFile(id,
  org_id,
  project_id,
  url,
  status,
  version,
  created_at,
  name,
  metadata);
export const ProjectFile$isProjectFile = (value) =>
  value instanceof ProjectFile;
export const ProjectFile$ProjectFile$id = (value) => value.id;
export const ProjectFile$ProjectFile$0 = (value) => value.id;
export const ProjectFile$ProjectFile$org_id = (value) => value.org_id;
export const ProjectFile$ProjectFile$1 = (value) => value.org_id;
export const ProjectFile$ProjectFile$project_id = (value) => value.project_id;
export const ProjectFile$ProjectFile$2 = (value) => value.project_id;
export const ProjectFile$ProjectFile$url = (value) => value.url;
export const ProjectFile$ProjectFile$3 = (value) => value.url;
export const ProjectFile$ProjectFile$status = (value) => value.status;
export const ProjectFile$ProjectFile$4 = (value) => value.status;
export const ProjectFile$ProjectFile$version = (value) => value.version;
export const ProjectFile$ProjectFile$5 = (value) => value.version;
export const ProjectFile$ProjectFile$created_at = (value) => value.created_at;
export const ProjectFile$ProjectFile$6 = (value) => value.created_at;
export const ProjectFile$ProjectFile$name = (value) => value.name;
export const ProjectFile$ProjectFile$7 = (value) => value.name;
export const ProjectFile$ProjectFile$metadata = (value) => value.metadata;
export const ProjectFile$ProjectFile$8 = (value) => value.metadata;

export class Metadata extends $CustomType {
  constructor(converted_urls, exported_urls, language, mime_type, proposal_id, spreadsheet, docx, user_validated_status) {
    super();
    this.converted_urls = converted_urls;
    this.exported_urls = exported_urls;
    this.language = language;
    this.mime_type = mime_type;
    this.proposal_id = proposal_id;
    this.spreadsheet = spreadsheet;
    this.docx = docx;
    this.user_validated_status = user_validated_status;
  }
}
export const Metadata$Metadata = (converted_urls, exported_urls, language, mime_type, proposal_id, spreadsheet, docx, user_validated_status) =>
  new Metadata(converted_urls,
  exported_urls,
  language,
  mime_type,
  proposal_id,
  spreadsheet,
  docx,
  user_validated_status);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$converted_urls = (value) => value.converted_urls;
export const Metadata$Metadata$0 = (value) => value.converted_urls;
export const Metadata$Metadata$exported_urls = (value) => value.exported_urls;
export const Metadata$Metadata$1 = (value) => value.exported_urls;
export const Metadata$Metadata$language = (value) => value.language;
export const Metadata$Metadata$2 = (value) => value.language;
export const Metadata$Metadata$mime_type = (value) => value.mime_type;
export const Metadata$Metadata$3 = (value) => value.mime_type;
export const Metadata$Metadata$proposal_id = (value) => value.proposal_id;
export const Metadata$Metadata$4 = (value) => value.proposal_id;
export const Metadata$Metadata$spreadsheet = (value) => value.spreadsheet;
export const Metadata$Metadata$5 = (value) => value.spreadsheet;
export const Metadata$Metadata$docx = (value) => value.docx;
export const Metadata$Metadata$6 = (value) => value.docx;
export const Metadata$Metadata$user_validated_status = (value) =>
  value.user_validated_status;
export const Metadata$Metadata$7 = (value) => value.user_validated_status;

export class Attachment extends $CustomType {}
export const Status$Attachment = () => new Attachment();
export const Status$isAttachment = (value) => value instanceof Attachment;

export class FileError extends $CustomType {}
export const Status$FileError = () => new FileError();
export const Status$isFileError = (value) => value instanceof FileError;

export class Initial extends $CustomType {}
export const Status$Initial = () => new Initial();
export const Status$isInitial = (value) => value instanceof Initial;

export class Other extends $CustomType {}
export const Status$Other = () => new Other();
export const Status$isOther = (value) => value instanceof Other;

export class Pending extends $CustomType {}
export const Status$Pending = () => new Pending();
export const Status$isPending = (value) => value instanceof Pending;

export class Questionnaire extends $CustomType {}
export const Status$Questionnaire = () => new Questionnaire();
export const Status$isQuestionnaire = (value) => value instanceof Questionnaire;

export class RFP extends $CustomType {}
export const Status$RFP = () => new RFP();
export const Status$isRFP = (value) => value instanceof RFP;

function converted_url_to_json_object(url) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.string(_pipe, "kind", $mime_types.to_string(url[0]));
  return $json_.string(_pipe$1, "url", url[1]);
}

function converted_exports_to_json_object(url) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.string(_pipe, "language", $iso639.to_string(url[0]));
  return $json_.string(_pipe$1, "url", url[1]);
}

function decode_converted_url() {
  return $decode.field(
    "kind",
    $mime_types.decoder(),
    (kind) => {
      return $decode.field(
        "url",
        $decode.string,
        (url) => { return $decode.success([kind, url]); },
      );
    },
  );
}

function decode_exported_url() {
  return $decode.field(
    "language",
    $iso639.decoder(),
    (language) => {
      return $decode.field(
        "url",
        $decode.string,
        (url) => { return $decode.success([language, url]); },
      );
    },
  );
}

export function encode_metadata(metadata) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.optional_string(
    _pipe,
    "language",
    (() => {
      let _pipe$1 = metadata.language;
      return $option.map(_pipe$1, $iso639.to_string);
    })(),
  );
  let _pipe$2 = $json_.optional_string(
    _pipe$1,
    "mime_type",
    (() => {
      let _pipe$2 = metadata.mime_type;
      return $option.map(_pipe$2, $mime_types.to_string);
    })(),
  );
  let _pipe$3 = $json_.optional_json(
    _pipe$2,
    "spreadsheet",
    (() => {
      let _pipe$3 = metadata.spreadsheet;
      return $option.map(_pipe$3, $spreadsheet.encode);
    })(),
  );
  let _pipe$4 = $json_.optional_json(
    _pipe$3,
    "docx",
    (() => {
      let _pipe$4 = metadata.docx;
      return $option.map(_pipe$4, $docx.encode);
    })(),
  );
  let _pipe$5 = $json_.optional_string(
    _pipe$4,
    "proposal_id",
    metadata.proposal_id,
  );
  let _pipe$6 = $json_.array(
    _pipe$5,
    "converted_urls",
    (() => {
      let _pipe$6 = metadata.converted_urls;
      let _pipe$7 = $dict.to_list(_pipe$6);
      return $list.map(_pipe$7, converted_url_to_json_object);
    })(),
  );
  let _pipe$7 = $json_.array(
    _pipe$6,
    "exported_urls",
    (() => {
      let _pipe$7 = metadata.exported_urls;
      let _pipe$8 = $dict.to_list(_pipe$7);
      return $list.map(_pipe$8, converted_exports_to_json_object);
    })(),
  );
  let _pipe$8 = $json_.bool(
    _pipe$7,
    "user_validated_status",
    metadata.user_validated_status,
  );
  return $json_.to_json(_pipe$8);
}

export function metadata_decoder() {
  return $decrypt.optional_field(
    "language",
    $iso639.decoder(),
    (language) => {
      return $decrypt.optional_field(
        "mime_type",
        $mime_types.decoder(),
        (mime_type) => {
          return $decrypt.optional_field(
            "proposal_id",
            $decode.string,
            (proposal_id) => {
              return $decode.optional_field(
                "converted_urls",
                toList([]),
                $decode.list(decode_converted_url()),
                (converted_urls) => {
                  return $decode.optional_field(
                    "exported_urls",
                    toList([]),
                    $decode.list(decode_exported_url()),
                    (exported_urls) => {
                      return $decrypt.optional_field(
                        "docx_converted_url",
                        $decode.string,
                        (docx_converted_url) => {
                          let _block;
                          if (docx_converted_url instanceof Some) {
                            let url = docx_converted_url[0];
                            _block = $list.append(
                              converted_urls,
                              toList([[new $mime_types.Docx(), url]]),
                            );
                          } else {
                            _block = converted_urls;
                          }
                          let converted_urls$1 = _block;
                          let converted_urls$2 = $dict.from_list(
                            converted_urls$1,
                          );
                          return $decrypt.optional_field(
                            "spreadsheet",
                            $spreadsheet.decoder($bit_array.from_string("")),
                            (spreadsheet) => {
                              return $decrypt.optional_field(
                                "docx",
                                $docx.decoder(),
                                (docx) => {
                                  return $decode.optional_field(
                                    "user_validated_status",
                                    false,
                                    $decode.bool,
                                    (user_validated_status) => {
                                      return $decode.success(
                                        new Metadata(
                                          converted_urls$2,
                                          $dict.from_list(exported_urls),
                                          language,
                                          mime_type,
                                          proposal_id,
                                          spreadsheet,
                                          docx,
                                          user_validated_status,
                                        ),
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function status_decoder() {
  return $decode.then$(
    $decode.string,
    (kind) => {
      if (kind === "initial") {
        return $decode.success(new Initial());
      } else if (kind === "pending") {
        return $decode.success(new Pending());
      } else if (kind === "other") {
        return $decode.success(new Other());
      } else if (kind === "questionnaire") {
        return $decode.success(new Questionnaire());
      } else if (kind === "rfp") {
        return $decode.success(new RFP());
      } else if (kind === "attachment") {
        return $decode.success(new Attachment());
      } else if (kind === "error") {
        return $decode.success(new FileError());
      } else {
        return $decode.failure(new FileError(), "Unknown status");
      }
    },
  );
}

export function status_to_string(status) {
  if (status instanceof Attachment) {
    return "attachment";
  } else if (status instanceof FileError) {
    return "error";
  } else if (status instanceof Initial) {
    return "initial";
  } else if (status instanceof Other) {
    return "other";
  } else if (status instanceof Pending) {
    return "pending";
  } else if (status instanceof Questionnaire) {
    return "questionnaire";
  } else {
    return "rfp";
  }
}

export function file_decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "org_id",
        $decode.string,
        (org_id) => {
          return $decode.field(
            "project_id",
            $decrypt.uuid(),
            (project_id) => {
              return $decode.field(
                "url",
                $decode.string,
                (url) => {
                  return $decode.field(
                    "name",
                    $decode.string,
                    (name) => {
                      return $decode.field(
                        "status",
                        status_decoder(),
                        (status) => {
                          return $decode.field(
                            "version",
                            $decode.int,
                            (version) => {
                              return $decode.field(
                                "created_at",
                                $decrypt.timestamp(),
                                (created_at) => {
                                  return $decode.field(
                                    "metadata",
                                    $decrypt.json(metadata_decoder()),
                                    (metadata) => {
                                      return $decode.success(
                                        new ProjectFile(
                                          id,
                                          org_id,
                                          project_id,
                                          url,
                                          status,
                                          version,
                                          created_at,
                                          name,
                                          metadata,
                                        ),
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_file(file) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.string(_pipe, "id", file.id);
  let _pipe$2 = $json_.string(_pipe$1, "org_id", file.org_id);
  let _pipe$3 = $json_.string(_pipe$2, "project_id", file.project_id);
  let _pipe$4 = $json_.string(_pipe$3, "url", file.url);
  let _pipe$5 = $json_.string(_pipe$4, "name", file.name);
  let _pipe$6 = $json_.string(_pipe$5, "status", status_to_string(file.status));
  let _pipe$7 = $json_.int(_pipe$6, "version", file.version);
  let _pipe$8 = $json_.json(
    _pipe$7,
    "created_at",
    $timestamp_.encode(file.created_at),
  );
  let _pipe$9 = $json_.json(_pipe$8, "metadata", encode_metadata(file.metadata));
  return $json_.to_json(_pipe$9);
}

/**
 * replace `file.url` by one the converted url if present in `file.metadata.converted_urls`
 */
export function use_converted_url(file, mime_type) {
  return new ProjectFile(
    file.id,
    file.org_id,
    file.project_id,
    (() => {
      let _pipe = file.metadata.converted_urls;
      let _pipe$1 = $dict.get(_pipe, mime_type);
      return $result.unwrap(_pipe$1, file.url);
    })(),
    file.status,
    file.version,
    file.created_at,
    file.name,
    file.metadata,
  );
}

export function use_initial_url(file) {
  let _pipe = file.metadata.mime_type;
  let _pipe$1 = $option.map(
    _pipe,
    (_capture) => { return use_converted_url(file, _capture); },
  );
  return $option.unwrap(_pipe$1, file);
}

export function set_converted_url(file, mime_type, url) {
  return new ProjectFile(
    file.id,
    file.org_id,
    file.project_id,
    file.url,
    file.status,
    file.version,
    file.created_at,
    file.name,
    (() => {
      let _record = file.metadata;
      return new Metadata(
        (() => {
          let _pipe = file.metadata.converted_urls;
          return $dict.insert(_pipe, mime_type, url);
        })(),
        _record.exported_urls,
        _record.language,
        _record.mime_type,
        _record.proposal_id,
        _record.spreadsheet,
        _record.docx,
        _record.user_validated_status,
      );
    })(),
  );
}

export function extract_key_from_s3_url(url) {
  return $bool.guard(
    !$string.starts_with(url, "s3://"),
    url,
    () => {
      let $ = (() => {
        let _pipe = $string.replace(url, "s3://", "");
        return $string.split(_pipe, "/");
      })();
      if ($ instanceof $Empty) {
        return url;
      } else {
        let key = $.tail;
        return $string.join(key, "/");
      }
    },
  );
}

export function is_already_converted(project_file, mime_type) {
  let _pipe = project_file.metadata.converted_urls;
  let _pipe$1 = $dict.get(_pipe, mime_type);
  return $result.is_ok(_pipe$1);
}

/**
 * Indicates the file should have a project linked, whether it exists, or not.
 */
export function has_proposal_linked(project_file) {
  let $ = project_file.status;
  if ($ instanceof Attachment) {
    return false;
  } else if ($ instanceof FileError) {
    return false;
  } else if ($ instanceof Initial) {
    return false;
  } else if ($ instanceof Other) {
    return false;
  } else if ($ instanceof Pending) {
    return false;
  } else if ($ instanceof Questionnaire) {
    return true;
  } else {
    return false;
  }
}

export function is_rfp(project_file) {
  let $ = project_file.status;
  if ($ instanceof Attachment) {
    return false;
  } else if ($ instanceof FileError) {
    return false;
  } else if ($ instanceof Initial) {
    return false;
  } else if ($ instanceof Other) {
    return false;
  } else if ($ instanceof Pending) {
    return false;
  } else if ($ instanceof Questionnaire) {
    return false;
  } else {
    return true;
  }
}

export function is_valid_status(project_file) {
  let $ = project_file.status;
  if ($ instanceof Attachment) {
    return true;
  } else if ($ instanceof FileError) {
    return false;
  } else if ($ instanceof Initial) {
    return false;
  } else if ($ instanceof Other) {
    return true;
  } else if ($ instanceof Pending) {
    return false;
  } else if ($ instanceof Questionnaire) {
    return true;
  } else {
    return true;
  }
}
